/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { BaseQueryFn, fetchBaseQuery } from '@reduxjs/toolkit/query'
import globalCookies from 'helpers/cookies'

/**********************************************************************************************************
 *   RTK QUERY BASE QUERY
 **********************************************************************************************************/
const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    credentials: 'include',
    prepareHeaders: (headers) => {
        const token = globalCookies.get('XSRF-TOKEN')
        if (token) headers.set('X-XSRF-TOKEN', token)
        return headers
    }
})

export const mercuryBaseQuery: BaseQueryFn = async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions)
    const timestamp = Date.now()

    return { ...result, meta: result.meta && { ...result.meta, timestamp } }
}
